import { getPmsConfig } from '@/api/independent/storyManage'
import { getDepartmentUserList as getDepartmentUserListApi } from '@/api/independent/ehafoKanban'
import { loopNode, local_get, local_set } from '@/utils'
import { assign } from 'lodash'
import { cloneDeep } from 'lodash'
const state = {
  viewType: local_get('story_manage_view_type') || 'kanban', //视图类型，table:表格视图，kanban:看板视图，gantt:甘特图
  pageSize: 20, //分页大小
  storyConfig: {}, //总配置
  storyConfigNoCache: false, //需求设置无缓存
  authUserInfo: {
    ceo: [],
    leader: [],
  },
  totalStoryStatusList: [], // 总的需求状态列表
  storyCategoryList: [], //需求分类列表
  ideaConfig: {}, //想法池配置
  allUserList: [], //所有用户列表
  //看板列表过滤条件
  kanbanListFilter: assign(
    {
      review_status: 0, // 审核状态 0-全部 1-待审核 2-审核通过 3-审核不通过
      in_planning_review_status: 0, // 需求方案 审核状态 0-全部 6-待审核 7-审核通过 8-审核不通过
      idea_groupid: 0, // 想法池分组 0-全部
      story_pool_review_status: 0, // 需求池 审核状态 0-全部 10-待审核 11-审核通过 12-审核不通过
    },
    local_get('story_manage_kanban_list_filter')
  ),
  onlySelf: local_get('story_manage_only_self') || false, //是否只看与我相关
  ideaListFoldState: local_get('story_manage_idea_list_fold_state') || true, //想法池列表折叠状态
  statusDescReadRecord: local_get('story_manage_status_desc_read_record') || {}, //流程状态描述阅读记录
  ganttExpandAllUser: local_get('story_manage_gantt_expand_all_user') || false, //甘特图是否默认展开人员配置
  ganttCalcWorkdays: local_get('story_manage_gantt_calc_workdays') || false, //甘特图是否计算工作日
}

const getters = {
  viewType: (state) => state.viewType,
  pageSize: (state) => state.pageSize,
  storyConfig: (state) => state.storyConfig,
  storyConfigNoCache: (state) => state.storyConfigNoCache,
  authUserInfo: (state) => state.authUserInfo,
  // 需求状态列表（过滤视图类型）
  storyStatusList: (state) => {
    return state.totalStoryStatusList.filter(
      (item) => !item.visible_view_type || item.visible_view_type == 'all' || item.visible_view_type.indexOf(state.viewType) > -1
    )
  },
  // 总的需求状态列表（不过滤视图类型）
  totalStoryStatusList: (state) => state.totalStoryStatusList,
  storyCategoryList: (state) => state.storyCategoryList,
  ideaConfig: (state) => state.ideaConfig,
  allUserList: (state) => state.allUserList,
  // 研发中心人员列表
  devCenterUserList: (state) => {
    let resList = []
    loopNode(state.allUserList, (item) => {
      if (item.id == 'p_2') {
        resList = [item]
      }
    })
    return resList
  },
  // 研发中心 · 技术开发部人员列表
  devDepartmentUserList: (state) => {
    let resList = []
    let info = cloneDeep(state.allUserList)
    loopNode(info, (item) => {
      if (item.id == 'p_45' || item.id == 'p_16') {
        resList.push(item)
      }
    })
    //去除主数据导致的input_title直接变为拼接name,导致树形组件名称对应不上，后续数据还是为一样，主要处理第一层级
    resList.forEach((lis) => {
      if (lis.children) {
        lis.children.forEach((i) => {
          i.input_title = i.name
        })
      }
    })

    return resList
  },
  kanbanListFilter: (state) => state.kanbanListFilter,
  onlySelf: (state) => state.onlySelf,
  ideaListFoldState: (state) => state.ideaListFoldState,
  statusDescReadRecord: (state) => state.statusDescReadRecord,
  ganttExpandAllUser: (state) => state.ganttExpandAllUser,
  ganttCalcWorkdays: (state) => state.ganttCalcWorkdays,
}

const mutations = {
  SET_VIEW_TYPE: (state, viewType) => {
    state.viewType = viewType
  },
  SET_STORY_CONFIG: (state, storyConfig) => {
    state.storyConfig = storyConfig
  },
  SET_STORY_CONFIG_NO_CACHE: (state, storyConfigNoCache) => {
    state.storyConfigNoCache = storyConfigNoCache
  },
  SET_AUTH_USER_INFO: (state, authUserInfo) => {
    state.authUserInfo = authUserInfo
  },
  SET_TOTAL_STORY_STATUS_LIST: (state, totalStoryStatusList) => {
    state.totalStoryStatusList = totalStoryStatusList
  },
  SET_STORY_CATEGORY_LIST: (state, storyCategoryList) => {
    state.storyCategoryList = storyCategoryList
  },
  SET_IDEA_CONFIG: (state, ideaConfig) => {
    state.ideaConfig = ideaConfig
  },
  SET_ALL_USER_LIST: (state, allUserList) => {
    state.allUserList = allUserList
  },
  SET_KANBAN_LIST_FILTER: (state, kanbanListFilter) => {
    state.kanbanListFilter = kanbanListFilter
  },
  SET_ONLY_SELF: (state, onlySelf) => {
    state.onlySelf = onlySelf
  },
  SET_IDEA_LIST_FOLD_STATE: (state, ideaListFoldState) => {
    state.ideaListFoldState = ideaListFoldState
  },
  SET_STATUS_DESC_READ_RECORD: (state, statusDescReadRecord) => {
    state.statusDescReadRecord = statusDescReadRecord
  },
  SET_GANTT_EXPAND_ALL_USER: (state, ganttExpandAllUser) => {
    state.ganttExpandAllUser = ganttExpandAllUser
  },
  SET_GANTT_CALC_WORKDAYS: (state, ganttCalcWorkdays) => {
    state.ganttCalcWorkdays = ganttCalcWorkdays
  },
}

const actions = {
  setViewType({ commit }, viewType) {
    commit('SET_VIEW_TYPE', viewType)
    local_set('story_manage_view_type', viewType)
  },
  // 获取需求状态列表
  async getStoryConfig({ state, commit }, extra = {}) {
    const noCache = state.storyConfigNoCache || extra.noCache || false
    if (!noCache && state.storyConfig && Object.keys(state.storyConfig).length > 0) {
      // 如果 state 中已经有数据，那么直接返回
      return state.storyConfig
    } else {
      // 否则调用 API 来获取新的数据
      const ret = await getPmsConfig()
      const configData = (ret && ret.code == 0 && ret.data) || {}
      const totalStoryStatusList = configData.story_status_list || []
      const storyCategoryList = (configData.story_category_list || []).map((_item) => {
        _item.value = parseInt(_item.value)
        return _item
      })
      const ideaConfig = configData.idea_pool_config || {}
      commit('SET_STORY_CONFIG', configData)
      commit('SET_TOTAL_STORY_STATUS_LIST', totalStoryStatusList)
      commit('SET_STORY_CATEGORY_LIST', storyCategoryList)
      commit('SET_IDEA_CONFIG', ideaConfig)
      commit('SET_STORY_CONFIG_NO_CACHE', false)
      const authUserInfo = {
        ceo: [parseInt(configData.ceo_role_id)],
        leader: [parseInt(configData.leader_role_id)],
      }
      commit('SET_AUTH_USER_INFO', authUserInfo)
      return configData
    }
  },
  setStoryConfigNoCache({ commit }, storyConfigNoCache) {
    commit('SET_STORY_CONFIG_NO_CACHE', storyConfigNoCache)
  },
  async getAllUserList({ state, commit }) {
    if (state.allUserList && state.allUserList.length > 0) {
      // 如果 state 中已经有数据，那么直接返回
      return state.allUserList
    } else {
      // 否则调用 API 来获取新的数据
      const ret = await getDepartmentUserListApi({ need_avatar: 1 })
      let list = (ret && ret.code == 0 && ret.data) || []
      let idMap = {}
      loopNode(list, (item, index, arr, extra) => {
        if ((item.id + '').startsWith('p_')) {
          // 部门不可被选中（在单选时）
          item.selectable = false
        }
        if (idMap[item.id]) {
          item.input_title = 'duplicate_' + item.name
        } else {
          item.input_title = item.name
          idMap[item.id] = 1
        }
        item.key = [extra.pid, item.id].filter(Boolean).join('_id:')
        arr.splice(index, 1, item)
      })

      commit('SET_ALL_USER_LIST', list)
      return list
    }
  },
  // 设置看板列表过滤条件
  setKanbanListFilter({ commit }, kanbanListFilter) {
    commit('SET_KANBAN_LIST_FILTER', kanbanListFilter)
    local_set('story_manage_kanban_list_filter', kanbanListFilter)
  },
  // 设置只看与我相关
  setOnlySelf({ commit }, onlySelf) {
    commit('SET_ONLY_SELF', onlySelf)
    local_set('story_manage_only_self', onlySelf)
  },
  // 设置想法池列表折叠状态
  setIdeaListFoldState({ commit }, ideaListFoldState) {
    commit('SET_IDEA_LIST_FOLD_STATE', ideaListFoldState)
    local_set('story_manage_idea_list_fold_state', ideaListFoldState)
  },
  setStatusDescReadByKey({ commit, getters }, key) {
    if (key) {
      const curRecord = getters.statusDescReadRecord
      curRecord[key] = new Date().getTime()
      commit('SET_STATUS_DESC_READ_RECORD', curRecord)
      local_set('story_manage_status_desc_read_record', curRecord)
    }
  },
  setGanttExpandAllUser({ commit }, ganttExpandAllUser) {
    commit('SET_GANTT_EXPAND_ALL_USER', ganttExpandAllUser)
    local_set('story_manage_gantt_expand_all_user', ganttExpandAllUser)
  },
  setGanttCalcWorkdays({ commit }, ganttCalcWorkdays) {
    commit('SET_GANTT_CALC_WORKDAYS', ganttCalcWorkdays)
    local_set('story_manage_gantt_calc_workdays', ganttCalcWorkdays)
  },
}

export default { state, getters, mutations, actions }
